import React, { useState, useEffect} from "react";
import useFetch from "../../../../commons/useFetch";
function DevelopmentGoal() {
    const [tabs, setTabs] = useState("A");
    const [hotelsData, setHotelsData] = useState([]);
    const { data: hotels } = useFetch('https://610ec1597f793c00174195b7.mockapi.io/api/hotels');

    const handleClick = (index) => {
        setTabs(index);
    };
    useEffect(() => {
        const filter = hotels.filter(e => e.status === tabs)
        setHotelsData(filter)
    }, [hotelsData])
    return (
        <div className="developmentGoal">
            <div className="aboutGoals">
                <div className="container">
                    <div className="aboutGoals_desktop">
                        <div className="row">
                            <div className="col-lg-6 col-12 imgAboutGoals">
                                <img className="img-fluid" src="/images/aboutGoals1.png" alt="" />
                            </div>
                        </div>
                        <div class="aboutGoalsStep mgt40 mgb45">
                            <div class="stepItem stepItem1">
                                <p>Giai đoạn phát triển</p>
                            </div><div class="stepItem stepItem2">
                                <p class="aboutGoalsYear"><span>2018 -</span> 2026</p>
                                <div>
                                    <p class="textAboutGoal">Phủ rộng Việt Nam với</p>
                                    <p class="textAboutGoal2">100 khách sạn</p>
                                </div>
                            </div>
                            <div class="stepItem stepItem3">
                                <p class="aboutGoalsYear"><span>2026 -</span> 2035</p>
                                <div>
                                    <p class="textAboutGoal">Mở rộng sang thị trường</p>
                                    <p class="textAboutGoal2">Quốc tế</p>
                                </div>
                            </div>
                            <div class="stepItem stepItem4">
                                <span class="bo-sung"></span>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-6 col-12 imgAboutGoals">
                                <img className="img-fluid" src="/images/aboutGoals1.png" alt="" />
                            </div>
                        </div>
                        <div class="backgroundImg">
                            <img src="/images/img-map.png" alt="img-map" />
                        </div>
                    </div>
                    <div class="aboutGoals__timeMobile">
                        <div class="mobileGoalsItem1">
                            <div>
                                <p>Giai đoạn phát triển</p>
                                <p class="aboutGoalsYear"><span>2018 -</span> 2026</p>
                                <div>
                                    <p class="textAboutGoal">Phủ rộng Việt Nam với</p>
                                    <p class="textAboutGoal2">100 khách sạn</p>
                                </div>
                                <div class="mobileGoalBoxImage">
                                    <img src="/images/aboutGoals1.png" alt="viet-name" />
                                    <img src="/images/img-map.png" alt="img-map" class="img_map" />
                                </div>
                            </div>
                        </div>
                        <div class="mobileGoalsItem1 mobileGoalsItem2">
                            <p class="aboutGoalsYear"><span>2026 -</span> 2035</p>
                            <div>
                                <p class="textAboutGoal">Mở rộng sang thị trường</p>
                                <p class="textAboutGoal2">Quốc tế</p>
                            </div>
                            <img src="/images/aboutGoals1.png" alt="viet-name" />
                        </div>
                        <div class=" mobileGoalsItem1 mobileGoalsItem3">
                        </div>
                    </div>
                </div>
            </div>
            <div className='aboutGoalsInfo'>
                <div className="container">
                    <div className="row ">
                        <div className="col-lg-6 col-12 col-md-6 tabBox" >
                            <div onClick={() => handleClick("A")}>
                                <span>KHÁCH SẠN ĐANG VẬN HÀNH</span>
                            </div>
                        </div>
                        <div className="col-lg-6 col-12 col-md-6 tabBox">
                            <div onClick={() => handleClick("P")}>
                                <span>KHÁCH SẠN SẮP VẬN HÀNH</span>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-3 col-12 col-md-3 colBox">
                            <h5><span className="numberHotels">{hotelsData.length}</span>Khách sạn</h5>
                        </div>
                        <div className="col-lg-9 col-12 col-md-9 colBox">
                            <ul className="hotelList">
                                {hotelsData.map((item,index)=>{
                                    return (
                                        <li key={index}>{item.name}</li>
                                    )
                                })
                            }
                            </ul>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 col-6 colImg">
                            <img className="img-fluid" src="/images/mandalaImg.png" alt="" />
                        </div>
                        <div className="col-lg-6 col-6 colImg">
                            <img className="img-fluid" src="/images/img-aboutus.jpg" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default DevelopmentGoal;
